import React from "react";
import { useParams } from "react-router";

import CategoryPageMultiplex from "../components/categories/CategoryPageMultiplex";
import CatalogHubPage from "../components/categories/root/CatalogHubPage";

export default function OnlineClassesPage() {
  const category = useParams<{ themeOrQuery?: string }>()?.themeOrQuery;

  return category ? <CategoryPageMultiplex /> : <CatalogHubPage />;
}
